import { z } from 'zod';
import { DayPlanKitFlagSchema } from '../visits/day-plan.schema.js';
// ---------------------------------------------------------------------------
// Kit registration at a patient visit (Domain 4 x Domain 5, REQ-KIT-013..022).
// ---------------------------------------------------------------------------
export const VISIT_KIT_STATUSES = {
    PREPARED: 'przygotowany',
    USED: 'zużyty',
};
export const VisitKitStatusSchema = z.enum(Object.values(VISIT_KIT_STATUSES));
export const SaveVisitKitItemRequestSchema = z.object({
    labKitId: z.number().int().positive(),
    /** Batch of a date-bearing kit; null/omitted for open-ended kits (REQ-KIT-006). */
    labKitExpirationId: z.number().int().positive().nullable().optional(),
    status: VisitKitStatusSchema.default(VISIT_KIT_STATUSES.PREPARED),
});
/**
 * Full replacement of the kits of one visit plus the new kit flag
 * (W white / R red / G green). An empty `items` array clears the kits.
 */
export const SaveVisitKitsRequestSchema = z.object({
    flag: DayPlanKitFlagSchema,
    items: z.array(SaveVisitKitItemRequestSchema).max(200),
});
export const VisitKitItemDtoSchema = z.object({
    id: z.number().int().positive(),
    patientVisitId: z.number().int().positive(),
    labKitId: z.number().int().positive(),
    labKitExpirationId: z.number().int().positive().nullable(),
    status: VisitKitStatusSchema,
});
export const VisitKitsResponseSchema = z.object({
    visitId: z.number().int().positive(),
    flag: DayPlanKitFlagSchema.nullable(),
    items: z.array(VisitKitItemDtoSchema),
});
//# sourceMappingURL=visit-kits.schema.js.map